import React, { Component } from 'react';

const guidUtil = require('../../../../utils/guid/guidUtil');

class StickyFixedHeader extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.id = guidUtil.generateGuid();

        this.handleScroll = this.handleScroll.bind(this);
    }
    
    componentDidMount()
    {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount()
    {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event)
    {
        var header = document.getElementById(this.state.id);
        var sticky = header.offsetTop;

        if (window.pageYOffset > sticky) 
        {
            header.classList.add("stickyHeader");
        } 
        else 
        {
            header.classList.remove("stickyHeader");
        }

    }

    render()
    {
        return <div id={this.state.id}>
                    {this.props.children}
                </div>
    }
}

export default StickyFixedHeader;